import { PAGES, PAGE_IDS } from 'js/constants/Pages';

export const getStartFrontend = (state) => {
  return state.app.startFrontend;
};

export const getCurrentPageData = (state, id) => {
  return state.app.pagesData?.[id] || {};
};

export const getSiteMetaData = (state, url) => {
  if (state.app.meta) {
    return state.app.meta[url] || state.app.meta['/'] || {};
  }
};

export const getCookieChoice = (state) => {
  return state.app.cookieChoice;
};

export const getLocale = (state) => {
  return state.app.locale;
};

// translation
export const getTranslationById = (state, id, fallback = '', hardset = false) => {
  const locale = getLocale(state);

  if (hardset) {
    return state.app.translations?.[id]?.[hardset] || fallback;
  }

  return state.app.translations?.[id]?.[locale] || fallback;
};

export const getSkillTagTranslation = (state, tag, fallback) => {
  let normalized = tag.replace(/ /g, '').toLowerCase();
  normalized = 'skill_tag_' + normalized;
  return getTranslationById(state, normalized, fallback);
};

export const getActivityCardFocus = (state) => {
  return state.app.activityCardFocus;
};

export const getPreviousLocation = (state) => {
  return state.app.previousLocation;
};

export const getReleaseActivityCardFocus = (state) => {
  return state.app.releaseActivityCardFocus;
};

// modal
export const getModalState = (state) => {
  return state.app.modal;
};

// online status
export const getOnlineStatus = (state) => {
  return state.app.isOnline;
};
